interface NoDeliveryAvailableProps {
  onSwitchToPickup: () => void
  onChangeAddress: () => void
}

export function NoDeliveryAvailable({ onSwitchToPickup, onChangeAddress }: NoDeliveryAvailableProps) {
  return (
    <div className="flex-1 flex flex-col items-center justify-center text-center py-12 px-4">
      <div className="size-16 flex items-center justify-center rounded-full bg-amber-100 mb-6">
        <span className="text-3xl">🛵</span>
      </div>
      
      <h2 className="text-xl/7 font-semibold text-text-primary mb-2">
        We don't deliver to this address
      </h2>
      
      <p className="text-text-secondary mb-8 max-w-xs">
        But you can still pick up from one of our nearby locations.
      </p>

      <button
        onClick={onSwitchToPickup}
        className="
          w-full max-w-xs py-3 px-6
          bg-(--color-brand-primary) text-white
          font-semibold rounded-xl
          shadow-card
          hover:shadow-card-hover
          transition-all duration-200
          focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--color-brand-primary) focus-visible:ring-offset-2
        "
      >
        Switch to Pickup
      </button>

      <button
        onClick={onChangeAddress}
        className="
          mt-4 py-2 px-4
          text-(--color-brand-primary) font-medium
          hover:underline
          focus-visible:outline-none focus-visible:underline
        "
      >
        Try a different address
      </button>
    </div>
  )
}
